export class datiFatturazione {
  RagioneSociale: string;
  Provincia: string;
  Citta: string;
  Cap: string;
  Indirizzo: string;
  Telefono: string;
  CodiceFiscale: string;
  PartitaIva: string;
}



// WEBPACK FOOTER //
// ./src/app/models/datiFatturazione.ts